import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'


const Experience = () => {
  return (
    <section id='experience'>
      <p className="section__subtitle" data-aos="fade-up" data-aos-anchor="#experience"  data-aos-duration='900'>Skills</p>
      <h2 data-aos="fade-up" data-aos-anchor="#experience"  data-aos-duration='700'>My Experience</h2>


      <div className="container experience__container">
        <div className="experience__frontend" data-aos="fade-right" data-aos-anchor=".experience__container"  data-aos-duration="900">
        <h3>Frontend Development</h3>
            <div className="experience__content">
              {/* HTML  */}
              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                  <h4>HTML</h4>
                  <small className='text-light'>Experienced</small>
                </div>
              </article>

              {/* CSS  */}
              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                  <h4>CSS</h4>
                  <small className='text-light'>Intermediate</small>
                </div>
              </article>

              {/* JavaScript  */}
              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>JavaScript</h4>
                <small className='text-light'>Experienced</small>
                </div>
              </article>
              
              {/* TypeScript  */}
              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>TypeScript</h4>
                <small className='text-light'>Experienced</small>
                </div>
              </article>

              {/* React  */}
              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>React</h4>
                <small className='text-light'>Intermediate</small>
                </div>
              </article>

              {/* Tailwind  */}
              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>Tailwind</h4>
                <small className='text-light'>Intermediate</small>
                </div>
              </article>

              {/* Next.js  */}
              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>Next.js</h4>
                <small className='text-light'>Experienced</small>
                </div>
              </article>
            </div>
        </div>

        <div className="experence__backend" data-aos="fade-left" data-aos-anchor=".experience__container"  data-aos-duration="1200">
           <h3>Backend & systems</h3>
            <div className="experience__content">
              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>Rust</h4>
                <small className='text-light'>Experienced</small>
                </div>
              </article>

              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>Python</h4>
                <small className='text-light'>Experienced</small>
                </div>
              </article>

              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>Node.js</h4>
                <small className='text-light'>Experienced</small>
                </div>
              </article>

              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>MongoDB</h4>
                <small className='text-light'>Intermediate</small>
                </div>
              </article>

              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>REST APIs</h4>
                <small className='text-light'>Experienced</small>
                </div>
              </article>

              <article className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" aria-hidden="true" focusable="false" />
                <div>
                <h4>Django</h4>
                <small className='text-light'>Basic</small>
                </div>
              </article>
            </div>
        </div>
      </div>
    </section>
  )
}

export default Experience